var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPickaxe28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17472 4.79808C5.10975 4.86407 5.04718 4.92762 4.9874 4.9874C4.92762 5.04718 4.86407 5.10975 4.79808 5.17472C4.00191 5.95863 2.85007 7.09271 3.66533 7.90797L4.46349 8.63851C1.47902 12.6776 1.31679 16.3671 1.38983 17.7949C1.4108 18.2047 1.60538 18.5759 1.89554 18.8661L1.97201 18.9426C2.42772 19.3983 3.19137 19.3125 3.54297 18.7724C4.51016 17.2867 6.38285 14.5072 8.31845 12.1669L20.3574 23.1858C21.2402 24.0686 22.589 24.1511 23.3701 23.3701C24.1511 22.589 24.0686 21.2402 23.1858 20.3574L12.1669 8.31844C14.5072 6.38283 17.2867 4.51015 18.7724 3.54297C19.3125 3.19137 19.3983 2.42771 18.9426 1.972L18.8661 1.89554C18.5759 1.60538 18.2047 1.4108 17.7949 1.38984C16.3671 1.31679 12.6776 1.47902 8.63851 4.46349L7.90797 3.66533C7.09271 2.85007 5.95863 4.00191 5.17472 4.79808Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickaxe28);
export default __webpack_public_path__ + "static/media/pickaxe_28.0d2bbbca.svg";
export { ForwardRef as ReactComponent };